import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getSearchResultClickedEvent } from 'marketplace-ui-tracking/events/marketplace';
import { useCallback } from 'react';
import { getProductTypeByAutocompleteResultItem, getSourceIdByAutocompleteResultItem } from '../utils/usageTracker';
export function useTrackAutocompleteSearchResultEvent({
  resultCount,
  searchTerm
}) {
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const getAutocompleteSearchResultEventProps = useCallback((item, resultIndex) => {
    return Object.assign({
      companyName: item.providerName,
      componentType: 'AutocompleteItem',
      listingId: item.resultType === 'COLLECTION' ? item.collectionId : item.listingId,
      resultCount,
      resultIndex,
      resultType: String(item.resultType),
      search: searchTerm,
      slug: item.slug,
      sourceId: getSourceIdByAutocompleteResultItem(item),
      type: getProductTypeByAutocompleteResultItem(item),
      value: item.resultType === 'QUERY' ? item.term : undefined
    }, item.resultType === 'COLLECTION' ? {
      category: item.slug,
      collectionId: item.collectionId
    } : {});
  }, [resultCount, searchTerm]);
  const trackAutocompleteSearchResultClickedEvent = useCallback((item, resultIndex) => {
    trackMarketplaceEvent(getSearchResultClickedEvent(getAutocompleteSearchResultEventProps(item, resultIndex)));
  }, [getAutocompleteSearchResultEventProps, trackMarketplaceEvent]);
  return {
    getAutocompleteSearchResultEventProps,
    trackAutocompleteSearchResultClickedEvent
  };
}
export function useTrackAutocompleteSearchResultEvent2({
  resultCount,
  searchTerm
}) {
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const getAutocompleteSearchResultEventProps = useCallback((item, resultIndex) => {
    var _item$listing, _item$listing2, _item$collection, _item$listing3, _item$listing4, _products$, _item$collection2, _item$collection3;
    const products = (_item$listing = item.listing) === null || _item$listing === void 0 ? void 0 : _item$listing.card.products;
    return Object.assign({
      companyName: (_item$listing2 = item.listing) === null || _item$listing2 === void 0 ? void 0 : _item$listing2.card.companyName,
      componentType: 'AutocompleteItem',
      listingId: item.resultType === 'COLLECTION' ? (_item$collection = item.collection) === null || _item$collection === void 0 ? void 0 : _item$collection.collectionId : (_item$listing3 = item.listing) === null || _item$listing3 === void 0 ? void 0 : _item$listing3.card.listingId,
      resultCount,
      resultIndex,
      resultType: String(item.resultType),
      search: searchTerm,
      slug: (_item$listing4 = item.listing) === null || _item$listing4 === void 0 ? void 0 : _item$listing4.card.slug,
      sourceId: products === null || products === void 0 ? void 0 : products.map(product => `${String(product.productType)}__${product.sourceId}`),
      type: products !== null && products !== void 0 && products.length ? (_products$ = products[0]) === null || _products$ === void 0 ? void 0 : _products$.productType : undefined,
      value: item.resultType === 'QUERY' ? item.term : undefined
    }, item.resultType === 'COLLECTION' ? {
      category: (_item$collection2 = item.collection) === null || _item$collection2 === void 0 ? void 0 : _item$collection2.slug,
      collectionId: (_item$collection3 = item.collection) === null || _item$collection3 === void 0 ? void 0 : _item$collection3.collectionId
    } : {});
  }, [resultCount, searchTerm]);
  const trackAutocompleteSearchResultClickedEvent = useCallback((item, resultIndex) => {
    trackMarketplaceEvent(getSearchResultClickedEvent(getAutocompleteSearchResultEventProps(item, resultIndex)));
  }, [getAutocompleteSearchResultEventProps, trackMarketplaceEvent]);
  return {
    getAutocompleteSearchResultEventProps,
    trackAutocompleteSearchResultClickedEvent
  };
}